<template>
<!--头部-->
  <div class="headerMain">
    <div style="line-height: 40px;display: flex">
      {{title}}
      <div style="width: 1px;height: 20px ;background: #E0E0E0;margin-left: 24px;transform: translateY(10px)" v-if="showSelect"></div>
      <div class="rightSelete" v-if="showSelect">
        <div class="leftSelect ">
          <div class="innerLeft">
            <el-dropdown @command="changeStore" @visible-change="oneArrow = !oneArrow" trigger="click" placement="bottom-start">
        <span class="el-dropdown-link">
          <span style="margin-right: 3px;color: #000000">{{value1}}</span>
          <i class="el-icon-arrow-down el-icon--right" v-if="!oneArrow"></i>
          <i class="el-icon-arrow-up el-icon--right" v-if="oneArrow"></i>
        </span>
              <el-dropdown-menu slot="dropdown" class="changePosition">
                <el-dropdown-item
                  v-for="item in options1"
                  :key="item.organization_id"
                  :command="item">
                  {{item.name}}
                  <span style="color: #E95646;font-weight: bold" v-if="$route.path == '/preTask' && item.pre_task_count != 0">({{item.pre_task_count}})</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div>
            <el-dropdown @command="changeStore2"  @visible-change="twoArrow = !twoArrow" trigger="click"  placement="bottom-start">
              <span class="el-dropdown-link">
                <span style="margin-right: 3px;color: #000000"  v-if="value2!= ''">{{value2}}</span>
                <span style="margin-right: 3px;color: #CCCCCC" v-else>Select</span>
                <i class="el-icon-arrow-down el-icon--right" v-if="!twoArrow"></i>
                <i class="el-icon-arrow-up el-icon--right" v-if="twoArrow"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="changePosition" v-if="value2!= ''">
                <el-dropdown-item
                  v-for="item in options2"
                  :key="item.organization_id"
                  :command="item">
                  {{item.name}}
                  <span style="color: #E95646;font-weight: bold" v-if="$route.path == '/preTask'&& item.pre_task_count != 0">({{item.pre_task_count}})</span>
                </el-dropdown-item>
              </el-dropdown-menu>
              <el-dropdown-menu slot="dropdown" class="changePosition" v-else>
                <el-dropdown-item disabled>no data</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    <!--   顶部聊天   -->
      <chat-box v-if="$route.path == '/Dispatch' || $route.path == '/dispatch_test'"></chat-box>
    </div>

    <!-- addnew Task btn box  -->
    <div class="addnewBox">
      <el-button type="primary" v-if="$route.path == '/Dispatch'" round @click="onclickAddNewTask">+NEW</el-button>
    </div>
    <addTask :addNewTaskDiog="addNewTaskDiog" @onCloseTaskDialog="onCloseTaskDialog"></addTask>

    <div class="rightBox">
      <el-dropdown @command="getItem" @visible-change="changeArrow">
  <span class="el-dropdown-link" style="cursor: pointer">
      <div v-if="emptyImg" style="display: inline-block;background:#E95646" class="emptyAdmin">
        <img src="../assets/image/avatar@2x.png" alt="">
      </div>
    <div  v-if="!emptyImg"  style="display: inline-block">
      <img :src="adminUrl" alt="" @load="loadingImg()">
    </div>
    <div class="loadImg" v-if="adminImg">
      <i class="el-icon-loading"></i>
    </div>
    <div style="display: inline-block" :class="emptyImg?'changePositions':''">
<!--    {{admin}}-->
    <i class="el-icon-arrow-down el-icon--right" v-if="arrow"></i>
    <i class="el-icon-arrow-up el-icon--right" v-if="!arrow"></i>
    </div>
  </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="a">Profile</el-dropdown-item>
          <el-dropdown-item command="b">Change Password</el-dropdown-item>
          <el-dropdown-item divided command="c">
            <i class="el-icon-switch-button"></i>Log out</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
<!--    profile弹框-->
    <el-dialog
      :close-on-click-modal="false"
      style="padding-top: 0"
      title="Profile"
      :visible.sync="changeProfile"
      width="40%">
<!--      <h1 style="color: #E95646;text-align: left">Chase Auto Parts</h1>-->
      <div style="text-align: left;font-weight: normal"  v-loading="profileLoading">
        <el-form :model="profileForm" label-position="top" :rules="rules2" status-icon ref="ruleForm" :show-message="false">
          <el-form-item label="Avatar" label-width="120px">
            <div class="avater">
              <vue-hover-mask>
                <!-- 默认插槽 -->
                <div v-if="emptyImg" style="background:#E95646" class="emptyAvatar">
                  <img src="../assets/image/avatar@2x.png" alt="">
                </div>
                <img v-if="!emptyImg" :src="imageUrl" class="avatar" @load="changeImg">
                <div class="avatarLoad" v-if="imageLoading">
                  <i class="el-icon-loading"></i>
                </div>
                <!-- action插槽 -->
                <template v-slot:action>
                  <el-dropdown trigger="click" @command="deleteImg" placement="bottom">
                  <span class="el-dropdown-link">
                  <i class="el-icon-camera" style="color: #F5F6FB;font-size: 24px" v-if="!imageLoading"></i>
                  </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-upload
                        class="avatar-uploader"
                        :action="actionUrl"
                        :headers="config"
                        :http-request="httpRequest"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                      >
                        <el-dropdown-item command="a">Upload a photo</el-dropdown-item>
                      </el-upload>
                      <el-dropdown-item command="b">Delete current photo</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </vue-hover-mask>
            </div>
          </el-form-item>
          <el-form-item label="Username" label-width="120px" required>
            <el-input  :placeholder="admin" autocomplete="off" disabled></el-input>
          </el-form-item>
<!--            <el-form-item  label="Name of hub (Sub Organization)" label-width="120px" prop="hubName" >-->
<!--              <el-input v-model="profileForm.hubName"  placeholder="name" autocomplete="off"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="Address of hub" label-width="120px" required>-->
<!--              <compose-input ref="usernameComponent" v-if="changeProfile"></compose-input>-->
<!--            </el-form-item>-->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
         <el-button type="danger"  @click="cancelChange" plain>Cancel</el-button>
    <el-button type="primary" @click="saveChange" round>Save</el-button>
  </span>
    </el-dialog>
<!--change password 弹框-->
    <el-dialog
      :close-on-click-modal="false"
      style="padding-top: 0"
      title="Change Password"
      :visible.sync="changePasswordDialog"
      width="30%">
      <div style="text-align: left;font-weight: normal">
        <el-form :model="passwordForm" label-position="top" :rules="rules" status-icon ref="ruleForms" :show-message="false">
          <el-form-item label="Current Password" label-width="120px" prop="curPassword" >
            <el-input v-model="passwordForm.curPassword"  placeholder="Current Password" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label=" New Password" label-width="120px" required>
            <div class="middleText">
              At least 8 characters, with one or more uppercase letters, lowercase letters, numbers
            </div>
            <change-pass ref="changePassForm"></change-pass>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
<!--    <el-button type="primary" plain >Cancel</el-button>-->
         <el-button type="danger"  @click="closeChangeDialog" plain>Cancel</el-button>
    <el-button type="primary" @click="saveChangePass" round>Save</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import addTask from "@/components/addTask";

import composeInput from "@/components/composeInput";
import changePass from "@/components/changePass";
import chatBox from "@/components/chatBox";
import {changePassWord, deleteAvatar, editUserMessage, getAvatar, getUserMessage} from "@/api/login";
import VueHoverMask from 'vue-hover-mask'
import {getAllProvice} from "@/api/tasks";
import {getOrgaList, getSubOrgaList} from "@/api/addressBook";
import startWs from '@/ws/ws'
import EventBus from "@/ws/eventBus";
import store from "@/store";
export default {
  components:{
    composeInput,changePass, VueHoverMask,chatBox,addTask
  },
  data(){
    return{
      processEnv:"",
      twoArrow:false,
      oneArrow:false,
      titleUpdate:'',
      showSelect:false,
      actionUrl: process.env.VUE_APP_BASE_URL,
      options1:[],
      options2:[],
      value1:"",
      value2:"",
      emptyImg:true,//无头像时的回显
      imageLoading: true,
      arrow:true,
      adminUrl:'',
      adminImg:true,
      token:'',
      admin:"",
      title:"",
      profileLoading:false,
      changeProfile:false,
      changePasswordDialog:false,
      profileForm:{
        hubName:'',
        address:'',
      },
      imageUrl:"",
      passwordForm:{
        curPassword:'',
        newPassword:"",
      },
      rules:{
        curPassword: [
          { required: true, message: '', trigger: 'blur' }
        ],
      },
      rules2:{
        hubName: [
          { required: true, message: '', trigger: 'blur' }
        ],
      },
      organization_id:"",
      loginUserInfo:{},


      addNewTaskDiog:false,
      titleadd:'Create a New Task',


    }
  },
  computed: {
    config() {
      return { token: this.token };
    },
  },
  created() {
   this.processEnv = process.env.VUE_APP_BASE_IMGURL
    this.token = localStorage.getItem('token')
    this.title = this.$route.meta.title
    this.admin = JSON.parse(localStorage.getItem('userInfo'))?.username
    this.loginUserInfo = JSON.parse(localStorage.getItem('userInfo'))
    // console.log(this.loginUserInfo.type,'ddd')
    //前提是admin 然后是 address book 以及rivers map 两个页面才会有

    // console.log('====admin---',this.loginUserInfo,JSON.parse(localStorage.getItem('userInfo')))

    if (this.loginUserInfo?.type == 0 || this.loginUserInfo?.type == 2){
      if (this.$route.path == '/addressBook' || this.$route.path == '/dirverMap' || this.$route.path =='/preTask') {
        this.showSelect = true
        this.gettopState()
      }
    }
    getUserMessage().then(res=>{
      // console.log("--刷新获取用户信息数据？？",res.data)
      localStorage.setItem('userInfoDetail',JSON.stringify(res.data))

      // if(res.data.id !=1){
      if(res.data.type !=0  && res.data.type !=2){
        store.commit('changeStore',res.data.id)
      }

      if (res.data?.avatar){
        this.adminUrl =process.env.VUE_APP_BASE_IMGURL +res.data.avatar
        // console.log(this.adminUrl,'thishtis')
        localStorage.setItem('avatar',this.adminUrl)
        this.emptyImg = false
      }else {
        this.adminImg = false
      }
      // this.$nextTick(() => {
      //   this.$refs.avatar.onload = () => {
      //     this.imageLoading = false
      //   }
      // })
    })
  },
  //监听路由的变化
  watch:{
    $route:{
      handler(val,oldval){
        // console.log(val);//新路由信息
        // console.log(oldval);//老路由信息
        this.title = val.meta.title
        // if (this.admin == 'admin'){
        if (this.loginUserInfo?.type == 0 || this.loginUserInfo?.type == 2){
          if (this.$route.path == '/addressBook' || this.$route.path == '/dirverMap' || this.$route.path =='/preTask') {
            this.showSelect = true
            this.gettopState()
          }else {
            this.showSelect = false
          }
        }
      },
      // 深度观察监听
      deep: true
    },
    showSelect:{
      deep:true,
     handler(){

     }
    }
  },
  methods:{
    onclickAddNewTask(){
      this.addNewTaskDiog = true
    },
    onCloseTaskDialog(){
      this.addNewTaskDiog = false
    },


    //改变第一个值
    changeStore(val){
     this.value1 = val.name
      this.organization_id = val.organization_id
     this.getSubData()
    },
    //改变第二个值
    changeStore2(val){
      if (this.$route.path == '/addressBook' || this.$route.path == '/preTask'){
        this.value2 =val.name
        this.$store.commit('changeStore',val.sub_organization_id)
      }else if (this.$route.path == '/dirverMap'){
        this.value2 =val.name
        this.$store.commit('changeStore',val.sub_organization_id)
        this.$store.commit('changeToken',val.token)
      }
    },
    //获取组织下拉数据
    gettopState(){
        getOrgaList().then(res=>{
          this.options1 = res.data
          this.value1 = res.data[0].name
          this.changeValue1 = res.data[0].name
          this.organization_id = res.data[0].organization_id
          this.$store.commit('changeOrgination',res.data[0].organization_id)
          // this.value1.label = res.data[0].name
          this.getSubData()
        })
    },
    getSubData(){
      //获取门店下拉数据
      getSubOrgaList({
        organization_id:this.organization_id
      }).then(res=>{
        this.options2 = res.data
        if (res.data.length !=0){
          this.changeValue2 = res.data[0].name
          this.value2 = res.data[0].name
          this.$store.commit('changeStore',res.data[0].sub_organization_id)
          this.$store.commit('changeToken',res.data[0].token)
        }else {
          this.value2 = ''
          this.$store.commit('changeStore','')
          this.$store.commit('changeToken','')
        }
      })
    },
    //删除照片
    deleteImg(i){
      if (i == 'b'){
        deleteAvatar().then(res=>{
          if (res.code == 200){
            this.emptyImg = true
          }
        })
      }
    },
    //图片加载
    loadingImg(){
      this.adminImg = false
    },
    changeImg(){
      this.imageLoading = false
    },
    //改变箭头
    changeArrow(i){
      if (i == true){
        this.arrow = false
      }else {
        this.arrow = true
      }
    },
    saveChange(){
      if (JSON.parse(localStorage.getItem('userInfo')).username == 'admin'){
          this.changeProfile = false
      }else {
        this.validateForms()
        this.$refs.usernameComponent.validateForm()
        if (this.validateForms() && this.$refs.usernameComponent.validateForm()){
          let address = this.$refs.usernameComponent.changeForm
          address['sub_organization_name'] = this.profileForm.hubName
          delete address['options']
          editUserMessage(address).then(res=>{
            if (res.code == 200){
              this.changeProfile = false
              this.$message({
                message:res.msg ,
                type: 'success'
              });
            }else{
              this.$message({
                message:res.msg ,
                type: 'warning'
              });
            }
          }).catch(err=>{
            this.$message({
              message:err.msg ,
              type: 'error'
            });
          })
        }
      }
    },
    closeChangeDialog(){
    this.changePasswordDialog = false
      this.$refs.ruleForms.resetFields();
    this.$refs.changePassForm.validateClear()
    },
    validateForms() {
      let flag = false
      this.$refs['ruleForm'].validate((valid) => {
        flag = valid
      })
      return flag
    },
    validateForm() {
      let flag = false
      this.$refs['ruleForms'].validate((valid) => {
        flag = valid
      })
      return flag
    },
    validateClear(){
      this.$refs.ruleForms.resetFields()
    },
    //修改密码确认框
    saveChangePass(){
      this.validateForm()
      this.$refs.changePassForm.validateForm()
     let test =  new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]{8,}$")
     let cp1 = this.$refs.changePassForm.passwordForm
      let cp2 = this.$refs.changePassForm.changePassRule
      if (this.validateForm() && this.$refs.changePassForm.validateForm()){
        // console.log(test.test(this.passwordForm.curPassword),'sss')
        if (!test.test(this.passwordForm.curPassword)) {
          this.$message({
            message: 'Current Password  is invalid',
            type: 'error'
          });
        } else if (!test.test(cp1.curPass)) {
          this.$message({
            message: 'Password must be At least 8 characters, with one or more uppercase letters, lowercase letters, numbers',
            type: 'error'
          });
        } else if (cp1.curPass != cp1.newPass) {
          this.$message({
            message: 'The new passwords do not match.',
            type: 'error'
          });
        }else {
          // 调接口修改密码
          let user = JSON.parse(localStorage.getItem('userInfo'))
          changePassWord({
            id:user.aid,
            old_password:this.passwordForm.curPassword,
            new_password:cp1.newPass,
            re_password:cp1.curPass,
          }).then(res=>{
            if (res.code == 200){
              this.$message({
                message:res.msg ,
                type: 'success'
              });
              localStorage.removeItem('token');
              localStorage.removeItem('userInfo');
              setTimeout(() => {
                this.$router.push({ path: '/login' });
              });
            }else {
              this.$message({
                message:res.msg ,
                type: 'error'
              });
            }
          }).catch(err=>{
            this.$message({
              message: err.msg,
              type: 'error'
            });
          })
        }
      }else {
      }
      },
    getItem(command){
      if (command == 'a'){
        this.changeProfile = true
        this.profileLoading = true
        getUserMessage().then(res=>{
          this.profileLoading = false
          if (res.code == 200){
            this.profileForm.hubName = res.data.sub_organization_name
            if (res.data.avatar != ''){
              this.imageUrl = this.processEnv + res.data.avatar
              this.emptyImg = false
            }else {
              this.emptyImg =true
              this.imageLoading = false
            }
            if (this.admin != 'admin'){
              for (let key of Object.keys(this.$refs.usernameComponent.changeForm)){
                this.$refs.usernameComponent.changeForm[key] = res.data[key]
              }
              getAllProvice().then(res=>{
                this.$refs.usernameComponent.changeForm.options = res.data.province
              })
            }else {
            }
            // this.$refs.usernameComponent.changeForm['options'] = [{label:'ON',value:'ON'}]
          }
        })


      }else if (command == 'b'){
      this.changePasswordDialog = true
      }else if (command == 'c'){
        localStorage.removeItem('token');
        localStorage.removeItem('userInfo');
        store.state.delyTaskData = {count:0};
        //ws 关掉 eventbus 注销
        this.$router.push('/login')
        console.log(this.$WebSocket, 'startWs')
        this.$WebSocket.disconnect(),
        this.$WebSocket.ws = null
        console.log(this.$WebSocket.ws,this.$WebSocket, 'startWs')
          EventBus.$off('bubble')
      }
    },
    cancelChange(){
      this.changeProfile = false
    },
    httpRequest(data){
      let _this = this
      let url =''
      let rd = new FileReader() // 创建文件读取对象
      let file = data.file
      rd.readAsDataURL(file) // 文件读取装换为base64类型
      rd.onloadend = function (e) {
        // this指向当前方法onloadend的作用域, this.result就是文件的base64， 这里可自由处理
        _this.$emit('successCBK', e.currentTarget.result)
         url = e.currentTarget.result
        this.imageLoading = true
        getAvatar({avatar:url}).then(res=>{
          if (res.code == 200){
            if (_this.emptyImg){
              _this.emptyImg = false
            }
              _this.imageUrl =_this.processEnv +res.data.image_url
            _this.adminUrl =_this.processEnv +res.data.image_url
            _this.$message({
              message: 'Photo has been uploaded',
              type: 'success'
            });
          }else {
            _this.$message({
                  message: res.msg,
                  type: 'warning'
                });
          }
        }).catch(err=>{
          // this.$message({
          //   message: err.msg,
          //   type: 'warning'
          // });
        })
      }

    },
    handleAvatarSuccess(res, file){
      this.imageUrl = URL.createObjectURL(file.raw);
    },
  }
}
</script>

<style scoped lang="less">
.headerMain{
  font-weight: bold;
  font-size: 16px;
  padding: 16px 0px;
  display: flex;
  justify-content: space-between;
  /deep/.el-dialog__header{
    padding-bottom: 0;
  }

  .leftSelect{
    display: flex;
    div{
      cursor: pointer;
    }
    .innerLeft{
      margin-right: 16px;
    }
    /deep/.el-select-dropdown__item{
      min-width: 170px;
    }

  }
  .rightSelete{
    display: flex;
    padding-left: 24px;
    /deep/.el-input__inner{
      background: none;
      border: none;
      font-size: 14px;
      font-family: SFPro-Bold, SFPro;
      font-weight: bold;
      color: #000000;
      line-height: 20px;
    }

  }
  .rightBox{
    .changePositions{
      transform: translateY(-80%);
      margin-left: 8px;
    }
    .emptyAdmin{
      width: 40px;
      height: 40px;
      border-radius: 8px;
      position: relative;
      img{
        width: 20px;
        height: 20px;
        //border-radius: 5px;
        //margin-right: 8px;
        //position: relative;
        //width: 20px;
        //height: 20px;
        //margin: 0 auto;
        position: absolute;
        top: 25%;
        left: 25%;
      }

    }
    img{
      width: 40px;
      height: 40px;
      border-radius: 5px;
      vertical-align: middle;
      margin-right: 8px;
      position: relative;
    }
    font-size: 14px;
    .loadImg{
      position: absolute;
      top: 0;
      width: 40px;
      height: 40px;
      background: rgba(0,0,0,0.6);
      border-radius: 5px;
      i{
        margin-top: 10px;
        color: #FFFFFF;
      }
    }
  }
  .middleText{
    font-size: 12px;
    font-family: SFPro-Regular, SFPro;
    font-weight: 400;
    color: #1F2D42;
    line-height: 20px;
  }
  .avater{
    .emptyAvatar{
      width: 80px;
      height: 80px;
      text-align: center;
      position: relative;
      img{
        width: 40px;
        height: 40px;
        margin: 0 auto;
        position: absolute;
        top: 25%;
        left: 25%;
      }
    }
    img{
      width: 80px;
      height: 80px;
      border-radius: 8px;
    }

  }
  .avatarLoad{
    position: absolute;
    top: 0;
    width: 80px;
    height: 80px;
    background: rgba(0,0,0,0.6);
    border-radius: 5px;
    text-align: center;
    i{
      margin-top: 25px;
      color: #FFFFFF;
      font-size: 30px;
    }
  }

}
.changePosition{
  margin-top: 0px!important;
}

.addnewBox{
  padding-right: 10px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: right;
}
</style>
